var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-dealer pad"},[_c('div',{staticClass:"pad"},[(_vm.dealer)?_c('dealer-form',{attrs:{"dealer":_vm.dealer},on:{"submitted":_vm.submitted}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }